import {
  tryParseNumber,
  tryParseNumberArray,
  parseMultiRef,
  parseComplexMultiRef,
} from 'utils/parse';
import { TASK_TYPE } from 'saas/constants';

const NUMBER_FIELDS = [
  'contract_type_ref',
  'infestation_level_ref',
  'setup_time',
  'setup_time_unit_ref',
  'site_infrastructure_ref',
  'infestation_level_ref',
  'surface_type_ref',
  'targets_ref',
  'treatments_ref',
  'visit_evaluation.average_time',
  'visit_evaluation.average_time_unit_ref',
  'visit_evaluation.per_year_curative',
  'visit_evaluation.per_year_maintenance',
  'places_ref',
  'accessibility_ref',
];

const mapVisitEvalution = values => {
  const visit = {};

  Object.keys(values).forEach(item => {
    if (item.indexOf('visit_evaluation.') > -1) {
      visit[item.replace('visit_evaluation.', '')] = values[item];
    }
  });

  return visit;
};

export const serializeDiagnosticValues = (type, values) => {
  if (values) {
    const serialized = NUMBER_FIELDS.reduce((agg, value) => {
      const copy = Object.assign({}, agg);
      copy[value] = tryParseNumber(agg[value]);

      return copy;
    }, values);

    const targets = tryParseNumberArray(
      serialized['targets[]'],
      serialized.targets
    );

    const treatments = tryParseNumberArray(
      serialized['treatments[]'],
      serialized.treatments
    );

    const places = tryParseNumberArray(
      serialized['places[]'],
      serialized.places
    );

    const accessibility = tryParseNumberArray(
      serialized['accessibility[]'],
      serialized.accessibility
    );

    const simpleList1 = parseMultiRef(serialized, 'simpleList1');

    const simpleList2 = parseMultiRef(serialized, 'simpleList2');

    const complexList = parseComplexMultiRef(serialized, values, 'complexList');

    if (
      targets.length ||
      treatments.length ||
      !isDiagnosticEmpty(type, values) ||
      places.length ||
      accessibility.length
    ) {
      return {
        ...serialized,
        visit_evaluation: mapVisitEvalution(serialized),
        targets,
        treatments,
        simpleList1,
        simpleList2,
        complexList,
        places,
        accessibility,
      };
    }
  }

  return null;
};

function isEmptyValueObject(candidate) {
  return (
    typeof candidate === 'object' &&
    candidate.value !== undefined &&
    candidate.value === ''
  );
}

function isOffString(candidate) {
  return typeof candidate === 'string' && candidate === 'off';
}

function isAnnexDiagEmpty(values) {
  const emptyNumber =
    1 + (values['complexList.complex_refs[].ref'] !== undefined ? 1 : 0);

  const filteredValues = Object.keys(values).filter(
    valueName =>
      !(
        isOffString(values[valueName]) ||
        (Array.isArray(values[valueName]) &&
          values[valueName].filter(
            str => !(str === 'off' || isEmptyValueObject(str))
          ).length === 0)
      )
  );

  return filteredValues.length === emptyNumber;
}

// Checking only default fields are set to determine emptiness of diagnostic
function isDiagnosticEmpty(type, values) {
  switch (type) {
    case TASK_TYPE.RAT:
      return Object.keys(values).length === 7;
    case TASK_TYPE.INSECT:
      return Object.keys(values).length === 9;
    case TASK_TYPE.DISINFECTION:
      return Object.keys(values).length === 3;
    case TASK_TYPE.OTHER_PESTS:
      return Object.keys(values).length === 9;
    case TASK_TYPE.ANNEX1:
      return isAnnexDiagEmpty(values);
    case TASK_TYPE.ANNEX2:
      return isAnnexDiagEmpty(values);
    default:
      return true;
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/reducers/serialize.js